"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStakeCapsParametersAddress = exports.getMaxVoterWeightRecordAddress = exports.getVoterWeightRecordAddress = exports.getTargetAccountAddress = exports.getDelegationRecordAddress = exports.getPoolConfigAddress = exports.getStakeAccountMetadataAddress = exports.getStakeAccountCustodyAddress = exports.getConfigAddress = void 0;
const web3_js_1 = require("@solana/web3.js");
const constants_1 = require("./constants");
const getConfigAddress = () => {
    return web3_js_1.PublicKey.findProgramAddressSync([Buffer.from("config")], constants_1.STAKING_PROGRAM_ADDRESS);
};
exports.getConfigAddress = getConfigAddress;
const getStakeAccountCustodyAddress = (stakeAccountPositionsAddress) => {
    return web3_js_1.PublicKey.findProgramAddressSync([Buffer.from("custody"), stakeAccountPositionsAddress.toBuffer()], constants_1.STAKING_PROGRAM_ADDRESS)[0];
};
exports.getStakeAccountCustodyAddress = getStakeAccountCustodyAddress;
const getStakeAccountMetadataAddress = (stakeAccountPositionsAddress) => {
    return web3_js_1.PublicKey.findProgramAddressSync([Buffer.from("stake_metadata"), stakeAccountPositionsAddress.toBuffer()], constants_1.STAKING_PROGRAM_ADDRESS)[0];
};
exports.getStakeAccountMetadataAddress = getStakeAccountMetadataAddress;
const getPoolConfigAddress = () => {
    return web3_js_1.PublicKey.findProgramAddressSync([Buffer.from("pool_config")], constants_1.INTEGRITY_POOL_PROGRAM_ADDRESS)[0];
};
exports.getPoolConfigAddress = getPoolConfigAddress;
const getDelegationRecordAddress = (stakeAccountPositions, publisher) => {
    return web3_js_1.PublicKey.findProgramAddressSync([
        Buffer.from("delegation_record"),
        publisher.toBuffer(),
        stakeAccountPositions.toBuffer(),
    ], constants_1.INTEGRITY_POOL_PROGRAM_ADDRESS)[0];
};
exports.getDelegationRecordAddress = getDelegationRecordAddress;
const getTargetAccountAddress = () => {
    return web3_js_1.PublicKey.findProgramAddressSync([Buffer.from("target"), Buffer.from("voting")], constants_1.STAKING_PROGRAM_ADDRESS)[0];
};
exports.getTargetAccountAddress = getTargetAccountAddress;
const getVoterWeightRecordAddress = (stakeAccountPositions) => {
    return web3_js_1.PublicKey.findProgramAddressSync([Buffer.from("voter_weight"), stakeAccountPositions.toBuffer()], constants_1.STAKING_PROGRAM_ADDRESS);
};
exports.getVoterWeightRecordAddress = getVoterWeightRecordAddress;
const getMaxVoterWeightRecordAddress = () => {
    return web3_js_1.PublicKey.findProgramAddressSync([Buffer.from("max_voter")], constants_1.STAKING_PROGRAM_ADDRESS);
};
exports.getMaxVoterWeightRecordAddress = getMaxVoterWeightRecordAddress;
const getStakeCapsParametersAddress = () => {
    return web3_js_1.PublicKey.findProgramAddressSync([Buffer.from("parameters")], constants_1.STAKE_CAPS_PARAMETERS_PROGRAM_ADDRESS);
};
exports.getStakeCapsParametersAddress = getStakeCapsParametersAddress;
